"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const colors_1 = require("../styles/colors");
const helpers_1 = require("../styles/helpers");
const BackdropModal_1 = __importDefault(require("./BackdropModal"));
const BottomSheet = ({ contentHeader, children, visible, onRequestClose, contentContainerStyle, }) => {
    const { height } = react_native_1.useWindowDimensions();
    const [layoutHeight, setLayoutHeight] = react_1.useState(0);
    const inputRange = [0, layoutHeight];
    const outputRange = [0, -layoutHeight];
    const pan = react_1.useRef(new react_native_1.Animated.Value(1000)).current;
    react_1.useEffect(() => {
        const openAnimation = () => react_native_1.Animated.timing(pan, { toValue: 0, duration: 300, useNativeDriver: false }).start();
        if (visible) {
            openAnimation();
        }
    }, [visible, pan]);
    const panResponder = react_1.useRef(react_native_1.PanResponder.create({
        onStartShouldSetPanResponder: () => false,
        onMoveShouldSetPanResponder: () => true,
        onPanResponderMove: react_native_1.Animated.event([
            null,
            {
                dy: pan,
            },
        ], { useNativeDriver: false }),
        onPanResponderRelease: () => {
            pan.flattenOffset();
        },
        onPanResponderEnd: (_, gestureState) => {
            if (gestureState.dy > 25) {
                react_native_1.Animated.timing(pan, { toValue: 1000, duration: 300, useNativeDriver: false }).start(() => {
                    onRequestClose && onRequestClose();
                });
            }
            else {
                react_native_1.Animated.timing(pan, { toValue: 0, duration: 300, useNativeDriver: false }).start();
            }
        },
    })).current;
    return (react_1.default.createElement(BackdropModal_1.default, { visible: visible, onRequestClose: () => {
            react_native_1.Animated.timing(pan, { toValue: 1000, duration: 300, useNativeDriver: false }).start(() => {
                onRequestClose && onRequestClose();
            });
        } },
        react_1.default.createElement(react_native_1.Animated.View, { onLayout: (e) => {
                setLayoutHeight(e.nativeEvent.layout.height);
            }, style: {
                maxHeight: height - 50,
                bottom: pan.interpolate({
                    extrapolate: 'clamp',
                    inputRange,
                    outputRange,
                }),
            } },
            react_1.default.createElement(react_native_1.View, Object.assign({}, panResponder.panHandlers),
                react_1.default.createElement(react_native_1.View, { style: styles.imageHandleContainer },
                    react_1.default.createElement(react_native_1.Pressable, { onPress: () => {
                            react_native_1.Animated.timing(pan, { toValue: 1000, duration: 300, useNativeDriver: false }).start(() => {
                                onRequestClose && onRequestClose();
                            });
                        } },
                        react_1.default.createElement(react_native_1.View, { style: styles.imageHandle }))),
                react_1.default.createElement(react_native_1.View, { style: styles.contentHeader }, contentHeader)),
            react_1.default.createElement(react_native_1.View, { style: react_native_1.StyleSheet.flatten([styles.bottomSheetContainer, { maxHeight: height - 200 }, contentContainerStyle]) }, children))));
};
exports.default = BottomSheet;
const styles = react_native_1.StyleSheet.create({
    bottomSheetContainer: {
        justifyContent: 'flex-end',
        backgroundColor: colors_1.Colors.card,
        padding: helpers_1.getSpacing(),
    },
    imageHandleContainer: {
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        alignItems: 'center',
        backgroundColor: colors_1.Colors.card,
    },
    imageHandle: {
        width: 25,
        borderRadius: 20,
        borderWidth: 2.5,
        marginVertical: helpers_1.getSpacing(1.6),
        backgroundColor: colors_1.Colors.gray,
    },
    contentHeader: {
        backgroundColor: colors_1.Colors.card,
    },
});
